import get from 'lodash/get';
import { CognitoState } from 'react-cognito';
import { buildAction } from './helpers';
import { invokeApi } from './api';
import { showModal, hideModal } from './modal';
import { getActiveSubscription } from './plan';
import { showLogin } from './user';
import {
  PLAN,
  SET_CHOSEN_PLAN,
  SET_ACTIVE_PLAN,
  SET_COUPON_CODE,
  SET_COUPON_ERROR,
  SET_PAYMENT_ERROR,
  SET_CHOSEN_SUMMARY,
  LOAD_LICENSES,
  SET_MODAL,
  MODAL,
} from '../constants';

export function showDownloadClipModal(
  clipId,
  license,
  backTo,
  onBackTo,
  goTo,
  onGoTo,
) {
  return function(dispatch, getState) {
    const state = getState();
    const clip = state.clips.clips[clipId];

    if (state.cognito.state !== CognitoState.LOGGED_IN) {
      return dispatch(
        showLogin({
          onAfterLogin: () => dispatch(hideModal()),
        }),
      );
    } else {
      dispatch(buildAction(SET_MODAL, MODAL.LICENSE_CLIP));
      return dispatch(
        showModal({
          clip: clip,
          usingLicense: license,
          backTo: backTo,
          onBackTo: onBackTo,
          goTo: goTo,
          onGoTo: onGoTo,
        }),
      );
    }
  };
}

export function licenseClip(clipId, description) {
  return async function(dispatch) {
    const license = await dispatch(
      invokeApi({
        path: `/v1/clips/${clipId}/licenses`,
        body: { description: description },
        method: 'POST',
      }),
    );

    dispatch(buildAction(LOAD_LICENSES, [license]));
    dispatch(getActiveSubscription());

    return license;
  };
}

export function getClipLicenses(clipId) {
  return async function(dispatch) {
    const licenses = await dispatch(
      invokeApi({
        path: `/v1/clips/${clipId}/licenses`,
      }),
    );

    dispatch(buildAction(LOAD_LICENSES, licenses));
    return licenses;
  };
}

export function getLicenses() {
  return async function(dispatch) {
    const licenses = await dispatch(
      invokeApi({
        path: `/v1/licenses`,
      }),
    );

    dispatch(buildAction(LOAD_LICENSES, licenses));
  };
}

export function clipDownloadables(clipId) {
  return invokeApi({
    path: `/v1/clips/${clipId}/download`,
  });
}

export function downloadClip(clipId, version, licensedAt) {
  return invokeApi({
    path: `/v1/clips/${clipId}/download`,
    body: { version: version, licensedAt: licensedAt },
    method: 'POST',
  });
}

export function showDownloadModal(clipId) {}



// WEBPACK FOOTER //
// ./src/actions/clips.js